var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrinter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2E2E2E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.67,
  d: "M15.889 15.889h1.555c.86 0 1.556-.697 1.556-1.556v-3.11c0-.86-.696-1.556-1.556-1.556H6.556c-.86 0-1.556.696-1.556 1.555v3.111c0 .86.696 1.556 1.556 1.556H8.11M9.667 19h4.666c.86 0 1.556-.696 1.556-1.556v-3.11c0-.86-.697-1.556-1.556-1.556H9.667c-.86 0-1.556.696-1.556 1.555v3.111c0 .86.697 1.556 1.556 1.556m6.222-9.333V6.556c0-.86-.697-1.556-1.556-1.556H9.667c-.86 0-1.556.696-1.556 1.556v3.11z"
})));
export default SvgPrinter;